require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./designing-calm-technology.json") })
        }
      }, "path---designing-calm-technology");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---designing-calm-technology!./.cache/json/designing-calm-technology.json
// module id = 488
// module chunks = 231608221292675